"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BLOCK_SCROLL_DURATION_MS = void 0;
var FoldableButton = require("./FoldableButton/Foldable");
var BlockPersister_1 = __importDefault(require("./BlockPersister"));
var FeatureFlag_1 = require("@CommonFrontendBackend/FeatureFlag");
var InlineBlockStyleMount_1 = __importDefault(require("./InlineBlockStyleMount"));
var lodash_1 = __importDefault(require("lodash"));
var IsBlockBrowser_1 = require("./IsBlockBrowser");
var MountSavedBlockDropzone_1 = require("./SavedBlockDropzone/MountSavedBlockDropzone");
var MountClonedBlockPlaceholder_1 = require("./ClonedBlockPlaceholder/MountClonedBlockPlaceholder");
var mobx_1 = require("mobx");
var DragStore_1 = require("Project/Stores/DragStore/DragStore");
var GetDropzoneFromContainerDrag_1 = require("./SavedBlockDropzone/GetDropzoneFromContainerDrag");
var BlockStyleVarsCompiler_1 = require("Styles/BlockStyles/BlockStyleVarsCompiler");
exports.BLOCK_SCROLL_DURATION_MS = 500;
var BlockController = (function () {
    function BlockController(block, blockStore, autoPersist, blockTypes, di, make, createUi, viewState, blockEvents, project, blockList, blockMenuActions, apiBaseUrl, $timeout, projectScrollTo, BlockMenuController, StyleCarousel, CarouselHandler, userIconFactory, collaboration, usingFeature, projectTelemetry, projectStore, dragStore, dropzonesStore, blockCreator, brandStore) {
        var _this = this;
        var _a, _b;
        this.theBlock = null;
        this.ui = null;
        var commentsCollaborationConsumer;
        if (di.has("commentsCollaborationConsumer")) {
            commentsCollaborationConsumer = di.get("commentsCollaborationConsumer");
        }
        blockEvents.on("blockRendered", function (elem, block) {
            if (block.$collabCreated) {
                return $timeout(function () {
                    var rect = elem.getBoundingClientRect();
                    if (rect.bottom < window.screen.height) {
                        return window.scrollTo(window.scrollX, window.scrollY + rect.height);
                    }
                });
            }
        });
        blockEvents.on("blockDeleted", function (elem, block) {
            if (block.$collabDeleted) {
                delete block.$collabDeleted;
                if (commentsCollaborationConsumer != null) {
                    commentsCollaborationConsumer.unsubscribe();
                }
                var rect = elem.getBoundingClientRect();
                if (rect.top < 0) {
                    return window.scrollTo(window.scrollX, window.scrollY - rect.height);
                }
            }
        });
        var isBlockBrowser = (0, IsBlockBrowser_1.isBlockBrowser)(block);
        var blockConfig = blockTypes[block.type];
        if (blockConfig == null) {
            throw new Error("Got an unknown block type");
        }
        if (blockConfig.wiring != null) {
            di.load(blockConfig.wiring);
        }
        var blockMenu = { ui: null };
        if (blockConfig.menu != null && blockMenuActions.length) {
            blockMenu = make(BlockMenuController, di.invoke(blockConfig.menu));
        }
        di.value("blockMenu", blockMenu);
        var carouselHandler = make(CarouselHandler, { block: block });
        this.theBlock = make(blockConfig.controller, {
            block: block,
            blockMenu: blockMenu,
            carouselHandler: carouselHandler,
        });
        var styleCarousel = di.instantiate(StyleCarousel, {
            block: block,
            blockUi: this.ui,
        });
        carouselHandler.addCarousel(styleCarousel.carousel.ui);
        var foldableWidget = make(FoldableButton);
        var isLockedByPermission = block.$userAction === "view";
        var isUneditable = isLockedByPermission ||
            (block.type === "Accept" && !usingFeature(FeatureFlag_1.FeatureFlag.Accept)) ||
            (["QuoteV2", "Quote"].includes(block.type) && !usingFeature(FeatureFlag_1.FeatureFlag.Quote));
        if (isUneditable) {
            if (!isLockedByPermission) {
                blockMenu = make(require("./DeleteOnlyMenu/DeleteOnlyMenu"), { isLockedByPermission: isLockedByPermission });
            }
            blockEvents.on("blockRendered", function (elem, _block) {
                if (block._id === _block._id) {
                    return $timeout(function () { return $(".project-block#".concat(block.$id, " content-area")).attr("contenteditable", "false"); });
                }
            });
        }
        var blockLockIcons = {};
        var getBlockLockIcon = function (lock) {
            if (!lock) {
                return null;
            }
            if (blockLockIcons[lock.userId] != null) {
                return blockLockIcons[lock.userId];
            }
            var userIcon = userIconFactory.create({
                firstName: lock.userFirstName,
                lastName: lock.userLastName,
                _id: lock.userId,
            }, {
                className: "large",
            });
            blockLockIcons[lock.userId] = userIcon;
            return userIcon;
        };
        var watchForBlockStore = function (scope) {
            return scope.$watch(function () {
                var cleanedBlock = lodash_1.default.omit(block, ["$ctrl"]);
                return cleanedBlock;
            }, function () { return blockStore.updateFromAngular(); }, true);
        };
        var createBlockBrowserAtTop = function () {
            projectTelemetry.addBlockButtonPressed(1);
            return blockList.createBlockBrowserAfter();
        };
        var createBlockBrowserAfter = function () {
            var index = blockList.getIndex(block);
            projectTelemetry.addBlockButtonPressed(index + 2);
            return blockList.createBlockBrowserAfter(block);
        };
        var usingSidebar = usingFeature(FeatureFlag_1.FeatureFlag.Sidebar);
        var getCreateBlockButtonIndex = function (isFirstCreateBlockButton) { return function () {
            var blockIndex = blockList.getIndex(block);
            var index = blockIndex + (isFirstCreateBlockButton ? 0 : 1);
            return index;
        }; };
        var onAddBlockFromMenu = function (isFirstCreateBlockButton) { return function (_a) {
            var blockType = _a.blockType, preset = _a.preset;
            var insertIndex = getCreateBlockButtonIndex(isFirstCreateBlockButton)();
            if (usingSidebar && dropzonesStore.isPersistent && insertIndex < dropzonesStore.currentDropzone.index) {
                dropzonesStore.setCurrentDropzone(dropzonesStore.currentDropzone.index + 1);
            }
            blockCreator.createAndInsert(blockType, insertIndex, preset);
        }; };
        this.ui = createUi(require("./Block.html"), {
            block: block,
            hasEditAccess: projectStore.isEditable,
            getBlockLockIcon: getBlockLockIcon,
            blockMenu: blockMenu.ui,
            viewState: viewState,
            theBlock: this.theBlock.ui,
            carouselHandler: carouselHandler,
            foldableWidget: foldableWidget.ui,
            firstCreateBlockButton: di.invoke(require("./CreateBlockButton").mountCreateBlockButtonInBlock, null, {
                isJustBelowFirstBlock: false,
                onClick: createBlockBrowserAtTop,
                onAddBlockFromMenu: onAddBlockFromMenu(true),
                getCreateBlockButtonIndex: getCreateBlockButtonIndex(true),
            }),
            createBlockButton: di.invoke(require("./CreateBlockButton").mountCreateBlockButtonInBlock, null, {
                isJustBelowFirstBlock: blockList.getIndex(block) === 0,
                onClick: createBlockBrowserAfter,
                onAddBlockFromMenu: onAddBlockFromMenu(false),
                getCreateBlockButtonIndex: getCreateBlockButtonIndex(false),
            }),
            createBlockBrowserAtTop: createBlockBrowserAtTop,
            createBlockBrowserAfter: createBlockBrowserAfter,
            isBlockBrowser: isBlockBrowser,
            usingFeature: usingFeature,
            shouldShowCarouselDrawer: function () {
                if (_this.ui.carouselHandler.currentCarousel == null) {
                    return false;
                }
                return _this.ui.carouselHandler.currentCarousel.shouldShow();
            },
            isLocked: function () {
                return !isUneditable && collaboration.isBlockLocked(block);
            },
            isUneditable: isUneditable,
            highlightDisabledMessage: function () {
                if (isUneditable && !isLockedByPermission) {
                    return blockMenu.addBorder();
                }
            },
            isFolded: function () {
                return this.isFoldable() && block.settings.foldable.isFolded;
            },
            isFoldable: function () {
                return block.settings.foldable && block.settings.foldable.isFoldable;
            },
            isFirstBlock: function () {
                return blockList.getIndex(block) === 0;
            },
            topDropzone: di.invoke(MountSavedBlockDropzone_1.mountSavedBlockDropzone)({
                blockStore: blockStore,
                position: MountSavedBlockDropzone_1.DropzonePosition.Top,
                blockList: blockList,
                dropzonesStore: dropzonesStore,
                dragStore: dragStore,
                projectScrollTo: projectScrollTo,
            }),
            bottomDropzone: di.invoke(MountSavedBlockDropzone_1.mountSavedBlockDropzone)({
                blockStore: blockStore,
                position: MountSavedBlockDropzone_1.DropzonePosition.Bottom,
                blockList: blockList,
                dropzonesStore: dropzonesStore,
                dragStore: dragStore,
                projectScrollTo: projectScrollTo,
            }),
            clonedBlockPlaceholder: di.invoke(MountClonedBlockPlaceholder_1.mountClonedBlockPlaceholder)({ blockId: block._id, blockList: blockList }),
            index: function () {
                return blockList.getIndex(block);
            },
            setActiveBlock: function (shouldActivate) {
                if (shouldActivate) {
                    viewState.activeBlock = true;
                    return blockEvents.emit("active");
                }
                else {
                    blockEvents.emit("inactive");
                    return (viewState.activeBlock = false);
                }
            },
            onDragOverContainer: function (event) {
                var isDraggingBlock = dragStore.findDragItemFromCurrentDrag(DragStore_1.DragType.SavedBlock) ||
                    dragStore.findDragItemFromCurrentDrag(DragStore_1.DragType.SidebarBlockModel);
                if (!isDraggingBlock) {
                    return;
                }
                var isTopDropzone = (0, GetDropzoneFromContainerDrag_1.getIsTopDropzoneFromContainerDrag)(event);
                var blockIndex = blockList.getIndex(blockStore);
                (0, mobx_1.runInAction)(function () {
                    var newIndex = isTopDropzone ? blockIndex : blockIndex + 1;
                    dropzonesStore.onOverDropzone(newIndex);
                });
                event.preventDefault();
            },
            $onElementRendered: function (element, property) {
                switch (property) {
                    case "blockElementContainer":
                        blockEvents.emit("blockContainerRendered");
                        break;
                    case "blockElement":
                        blockEvents.emit("blockRendered", element[0], block);
                        block.$initialRenderComplete = true;
                        if (block.$scrollTo) {
                            projectScrollTo(element, {
                                offset: 10,
                                time: exports.BLOCK_SCROLL_DURATION_MS,
                                scrollingElement: ".content-container__scroll-container",
                            });
                        }
                        break;
                }
                return element.on("$destroy", function () {
                    blockEvents.emit("blockDeleted", element[0], block);
                    return commentsCollaborationConsumer != null ? commentsCollaborationConsumer.unsubscribe() : undefined;
                });
            },
            inlineBlockStyle: di.invoke(InlineBlockStyleMount_1.default),
            $init: function (scope) {
                if (autoPersist && !isUneditable) {
                    make(BlockPersister_1.default, {
                        options: {
                            watchObject: "ui.block",
                            scope: scope,
                            apiRoute: "".concat(apiBaseUrl, "/projects/").concat(project._id, "/blocks/").concat(block._id),
                            expectedSuccessMsg: "Block Updated",
                            onPersisted: function () {
                                return projectTelemetry.projectEdited(project);
                            },
                        },
                    });
                }
                if (projectStore.isEditable) {
                    if (commentsCollaborationConsumer != null) {
                        commentsCollaborationConsumer.subscribe();
                    }
                }
                var autorunDisposer = (0, mobx_1.autorun)(function () {
                    var styleVars = (0, BlockStyleVarsCompiler_1.compileBlockStyleVars)(blockStore.proxyBlockModel, brandStore.allColors);
                    $timeout(function () {
                        if (_this.ui) {
                            _this.ui.blockStyleVars = styleVars;
                        }
                    });
                });
                scope.$on("$destroy", function () {
                    autorunDisposer();
                });
                return watchForBlockStore(scope);
            },
            backgroundType: ((_b = (_a = block.style) === null || _a === void 0 ? void 0 : _a.background) === null || _b === void 0 ? void 0 : _b.type) || "color",
            scrollLockMenu: usingFeature(FeatureFlag_1.FeatureFlag.TextBlockBackgroundStylingMenu),
        });
    }
    return BlockController;
}());
exports.default = BlockController;
